import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  themeSignal = signal<string>(localStorage.getItem('theme') ?? 'light-theme');
  themeLabelMap = {
    'light-theme': 'Light Theme',
    'dark-theme': 'Dark Theme',
  } as const;

  setTheme(newTheme: string): void {
    localStorage.setItem('theme', newTheme);
    this.themeSignal.set(newTheme);
  }
  getTheme(): string {
    return this.themeSignal();
  }

  buildThemeClassName(theme: string) {
    const label: string[] = theme.toLowerCase().split(' ');
    const newTheme: string = label.join('-');
    return newTheme;
  }

  getThemeLabel(): string {
    const themeKey = this.themeSignal() as keyof typeof this.themeLabelMap;
    return this.themeLabelMap[themeKey] ?? 'Light Theme';
  }
}
